import { useAppSelector } from 'store/hooks';
import { lazy, useEffect, useState } from 'react';
import { UserAuth } from 'store/auth';
import { useParams } from 'react-router-dom';
import { useCatalogDataByAlias } from 'hooks/useCatalog';
import { useSelector } from 'react-redux';
const Home = lazy(() => import('app/home'));

export default function HomeRouteWrapper(props: any) {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const [showHomePage, setShowHomePage] = useState<boolean>(false);
    const urlParams = useParams();
    const catalogAlias = urlParams?.catalog ?? '';
    const currentCatalog = useCatalogDataByAlias(urlParams?.catalog ?? '');
    const displayDefaultCatalog = useSelector((state: any) => state.auth?.userInfo?.displayDefaultCatalog);
    const isOnCatalogRoute = !!catalogAlias;

    useEffect(() => {
        const homeUrl = userAuth.userInfo?.homeUrl;
        if (!isOnCatalogRoute && homeUrl && homeUrl != '/home') {
            // On /home route with a configured start page — redirect to it
            window.location.href = homeUrl;
        } else if (catalogAlias && (!currentCatalog || (currentCatalog.is_system_ind == 'Y' && !displayDefaultCatalog))) {
            // Catalog not found or system catalog with default catalog disabled — redirect to homeUrl
            window.location.href = homeUrl ?? '/home';
        } else {
            setShowHomePage(true);
        }
    }, [userAuth.userInfo?.homeUrl, isOnCatalogRoute, catalogAlias, currentCatalog, displayDefaultCatalog]);

    return showHomePage ? <Home {...props} /> : null;
}
